"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "What is included in a standard property inspection?",
    answer: "Our comprehensive inspections cover all major systems: roofing, structural integrity, electrical panels, plumbing fixtures, and HVAC performance. We provide a detailed digital report including high-resolution photos of every finding for your records."
  }, {
    question: "How long does the inspection process typically take?",
    answer: "A standard residential inspection usually takes between 2 to 4 hours depending on the size and age of the property. We recommend that clients attend the final 30 minutes for a personalized walk-through of the key findings."
  }, {
    question: "When will I receive my final inspection report?",
    answer: "We understand that timing is critical in real estate transactions. You will receive a full, easy-to-read digital report via email within 24 hours of the inspection completion—often on the very same day."
  }, {
    question: "Are your inspectors fully certified and insured?",
    answer: "Absolutely. All our inspectors are InterNACHI certified and maintain full professional liability and errors and omissions insurance. We strictly adhere to the highest industry standards to ensure your investment is protected."
  }, {
    question: "Do you offer specialized testing like radon or sewer scopes?",
    answer: "Yes, we offer a range of additional services including radon testing, mold assessments, sewer scope inspections, and thermal imaging. These can be added to any standard inspection for a more complete property evaluation."
  }];
  return <section data-section-id="28440" id="frequently-asked-questions" ref={ref} className={cn("py-40 bg-background w-full transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-5xl font-semibold text-center mb-16 tracking-tight text-foreground">
            Frequently Asked Questions
          </h2>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/60 last:border-0 px-2" data-index={i}>
                <AccordionTrigger className="text-xl font-medium text-foreground hover:text-primary hover:no-underline transition-colors py-6 text-left [&[data-state=open]]:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-lg leading-relaxed pb-6">
                  <div className="animate-in fade-in slide-in-from-top-2 duration-[400ms] ease-out">
                    {faq.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}